export const comments_3374310 = {"data":{"data":[],"links":{}}}